import React from 'react'
import { Link } from 'react-router-dom'
import { RsIcon } from '../icons'
import { usePortalFeatureLock } from '../../hooks/usePortalFeatureLock'

const GATE_COPY = {
  paywall: {
    title: 'Upgrade Required',
    message:
      'This feature requires an active membership. Upgrade your plan to unlock deal tools, email, files, digest, and more.',
    action: 'Upgrade Plan',
    actionTo: '/payment',
  },
  admin: {
    title: 'Access Not Enabled',
    message:
      'This feature has not been enabled for your account. Please contact the platform administrator if you need access.',
    action: 'Back to Home',
    actionTo: '/dashboard',
  },
}

export default function FeatureAccessGate({ children }) {
  const { locked, lockType, label } = usePortalFeatureLock()

  if (!locked) return children

  const copy = GATE_COPY[lockType] || GATE_COPY.paywall
  const featureLabel = label ? `"${label}"` : 'This feature'

  return (
    <div className="portal-feature-gate">
      <div className="portal-feature-gate-content" aria-hidden="true">
        {children}
      </div>
      <div
        className="portal-feature-gate-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="portal-feature-gate-title"
      >
        <div className="portal-feature-gate-card">
          <div className="portal-feature-gate-icon">
            <RsIcon name="lock" size="xl" />
          </div>
          <h2 id="portal-feature-gate-title">{copy.title}</h2>
          <p className="portal-feature-gate-msg-en">
            {lockType === 'admin'
              ? `${featureLabel} is not enabled on your account. ${copy.message}`
              : `${featureLabel} is locked. ${copy.message}`}
          </p>
          <Link to={copy.actionTo} className="portal-feature-gate-btn primary">
            {copy.action}
          </Link>
        </div>
      </div>
    </div>
  )
}
